export default __webpack_public_path__ + "static/media/MSG.f30028d3.png";